import {get} from 'lodash'
import axios from 'axios'

const defaultItems = [
	{ label: 'first_name',	title: 'Имя',	required: true },
	{	label: 'last_name',	title: 'Фамилия',	required: true },
	{	label: 'father_name',	title: 'Отчество',	required: false },
	{	label: 'birthday',	title: 'Дата рождения',	required: true },
	{	label: 'email',	title: 'Почта',	required: true }
]

export default class Form {
	constructor (init, type = '', parentId) {
		this.type = type
		this.parentId = parentId

		this.setDefault(init)
	}

	setDefault (init) {
		const result = this.createFormObject(init)
		this.id = result.id
		this.content = result.content
	}
	createFormObject (obj) {
		try {
			if (!get(obj, 'id')) {
				// eslint-disable-next-line
				throw null
			}

			if (!get(obj, 'content')) {
				throw obj.id
			}

			const newContent = JSON.parse(obj.content)
			if (!get(newContent, 'selected') ||
				!get(newContent, 'allowed')
			) {
				throw obj.id
			}

			if (Array.isArray(newContent.allowed)) {
				newContent.allowed = newContent.allowed.map(a => new ItemAllowed(a))
			} else {
				newContent.allowed = []
			}

			if (Array.isArray(newContent.selected)) {
				newContent.selected = newContent.selected.map(a => new ItemSelected(a))
			} else {
				newContent.selected = []
			}

			return {
				id: obj.id,
				content: newContent
			}
		} catch (id) {
			return {
				id: id,
				content: {
					allowed: defaultItems,
					selected: []
				}
			}
		}
	}

	isCustomElement (str) {
		return !str || str.indexOf('custom') >= 0
	}

	get createFormJSON () {
		if (this.content) {
			this.content.selected = this.content.selected.map((item, i) => {
				if (this.isCustomElement(item.label)) {
					item.label = `custom_${i}`
				}
				return item
			})

			try {
				const json = JSON.stringify(this.content)
				return json
			} catch (e) {
				console.log(e)
				return ''
			}
		}
	}

	updateForm ({ force }) {
		const formData = new FormData()
		formData.append('content', this.createFormJSON)

		return axios.post(`/api/form/${this.id}${force ? '?force=true' : ''}`, formData)
			.then(res => {
				this.setDefault(res.data.data)
				return res
			})
			.catch(err => {
				console.error(err)
				return err.response
			})
	}

	createForm () {
		const formData = new FormData()
		formData.append('content', this.createFormJSON)
		formData.append('model_type', this.type)
		formData.append('model_id', this.parentId)

		return axios.post(`/api/form`, formData)
			.then(res => {
				this.setDefault(res.data.data)
				return res
			})
			.catch(err => {
				console.error(err)
				return false
			})
	}
}

export class ItemAllowed {
	constructor (init = {}) {
		this.label = get(init, 'label', '')
		this.title = get(init, 'title', '')
		this.required = get(init, 'required', false)
	}
}
export class ItemSelected extends ItemAllowed {
	constructor (init = {}) {
		super(init)
		this.type = get(init, 'type', 'text')
		this.correct = get(init, 'correct', this.type === 'checkbox' ? [] : '')

		this.answers = []
		if (get(init, 'answers') && Array.isArray(init.answers)) {
			this.answers = init.answers.map(a => new AnswerSelected(a))
		}
	}
	isCheckedCheckbox (val) {
		if (!Array.isArray(this.correct)) return
		return this.correct.includes(val)
	}
	setCheckbox (val) {
		const index = this.correct.indexOf(val)
		if (index >= 0) {
			this.correct.splice(index, 1)
		} else {
			this.correct.push(val)
		}
	}
	deleteAnswer (item) {
		const answersIndex = this.answers.findIndex(a => a.value === item.value)
		if (answersIndex >= 0) {
			this.answers.splice(answersIndex, 1)
		}

		if (this.type === 'checkbox') {
			const correctIndex = this.correct.findIndex(c => c === item.value)
			if (correctIndex >= 0) {
				this.correct.splice(correctIndex, 1)
			}
		} else {
			if (this.correct === item.value) {
				this.correct = ''
			}
		}
	}
	static answersId = new Set()
}

export class AnswerSelected {
	constructor (init = {}) {
		this.name = get(init, 'name', '')

		if (get(init, 'value')) {
			this.value = init.value
		} else {
			do {
				this.value = Math.random().toString(36).substr(2, 6) // генерирует рандомную строку в 6 символов
			} while (ItemSelected.answersId.has(this.value)) // проверка на уникальность
			ItemSelected.answersId.add(this.value)
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/Form.js